module.exports = __webpack_public_path__ + "img/hehuor.8d873f71.png";